import React from "react";
import { Star } from "lucide-react";

/**
 * Quiet one-liner tucked between the hero and the podcast content.
 * A whisper of credibility — not a wall of awards. The full press kit
 * lives at /press-kit for anyone who wants receipts.
 */
export const FeaturedIn = () => {
    return (
        <section
            data-testid="featured-in-strip"
            aria-label="Coach Melissa — Presidential Lifetime Achievement Award recipient"
            className="border-b border-lilac-200/50 bg-white/40 backdrop-blur"
        >
            <div className="mx-auto max-w-4xl px-6 md:px-10 py-4 md:py-5">
                <p className="text-center text-xs md:text-sm text-lilac-700 leading-relaxed">
                    <Star className="inline w-3.5 h-3.5 -mt-0.5 mr-1.5 text-gold-deep" />
                    <span className="italic">
                        Presidential Lifetime Achievement Award recipient · Featured in{" "}
                        <span className="text-lilac-900 font-medium">Phenomenal Overcomer</span>,{" "}
                        <span className="text-lilac-900 font-medium">Hoinser Queens</span>,{" "}
                        <span className="text-lilac-900 font-medium">Heidens Magazine</span>
                    </span>
                    <a
                        href="/press-kit"
                        data-testid="featured-in-press-kit-link"
                        className="ml-2 text-gold-deep hover:text-lilac-900 font-semibold not-italic underline-offset-4 hover:underline transition-colors"
                    >
                        Press kit &rarr;
                    </a>
                </p>
            </div>
        </section>
    );
};
